import { render } from "./WaterMarks.vue?vue&type=template&id=87916aea&scoped=true"
const script = {}

import "./WaterMarks.vue?vue&type=style&index=0&id=87916aea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87916aea"]])

export default __exports__